// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";

import { getTheme } from "guiutils";
import { Theme } from "types";

import SvgEpmLogo from "icons/logoTextEm";

import "../page/Login.scss";

function renderCopyright(isEpm: boolean) {
  return (
    <div style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
      {isEpm ?
        <>
          <span className="login_copyright">2026, EPM Energieplan & Management</span>
          <span className="login_copyright">
            by <a href="https://www.embyt.com">embyt GmbH</a>
          </span>
        </>
      : <span className="login_copyright">
          2026, <a href="https://www.embyt.com">embyt GmbH</a>
        </span>
      }
    </div>
  );
}

// common frame of the pages shown before login: logo, page content and copyright footer
function LoginLayout(props: { children: React.ReactNode }) {
  const isEpm = getTheme() === Theme.EPM;
  return (
    <div id="login">
      <div id="login_box">
        <div id="login_inner">
          <div id="login_right">
            <SvgEpmLogo id="logo" className={`logo ${isEpm ? "" : "noEM "}`} />
            {props.children}
          </div>
          {/*renderCopyright(isEpm)*/}
        </div>
      </div>
    </div>
  );
}

export default LoginLayout;
